import { isRouteErrorResponse, useLocation, useNavigate, useRouteError } from 'react-router';
import { useEffect } from 'react';

const ErrorPage = () => {
	const router = useLocation();
	const navi = useNavigate();
	const error = useRouteError();

	useEffect(() => {
		// 파로스에서 넘어올때 .html 제거
		if (isRouteErrorResponse(error) && error?.status === 404) {
			const { pathname, search, hash } = router;
			const cleanedPath = `${pathname.replace(/\.html$/, '')}${search}${hash}`;
			navi(cleanedPath);
		}
	}, []);

	return <></>;
};

export default ErrorPage;
